import React, { useEffect, useState, useCallback } from "react";
import PageHeader from "components/molecules/PageHeader";
import AppTable from "components/organisms/app-table";
import TableDataSpan from "components/organisms/app-table/TableDataSpan";
import { BASE_URL, BASE_URL_PROD_POCKET } from "services/http";
import Alert from "components/atoms/Alert";
import AppModal from "../../../components/organisms/CustomModal";
import {
  toggleAppEnv,
  toggleModal,
  getPocketTier,
  getPocketBal,
  storeNavKey,
} from "redux/app/app.action";
import { connect } from "react-redux";
import Button from "components/atoms/Button";
import { useNavigate } from "react-router-dom";
import { ToCamelCase } from "../../../components/atoms/CaseManager";
import CopyText from "../../../components/atoms/CopyText";
import moment from "moment";
import { handleException } from "../../../utils";
import { getValues } from "../../../services/storage";
import SideComponent from "./SideComponent";
import axios from "axios";
import { TransactionsHeader } from "../../../components/molecules/tableExport";
import { data } from "autoprefixer";
import SubNav from "../../../components/organisms/SubNav";
import refreshIcon from "../../../assets/svg/refresh.svg";

const searchKeys = [
  { title: "batchId", value: null, link: null, action: () => null },
].sort();

const Transactions = ({
  toggleModal,
  modalState,
  bearerToken,
  publicKey,
  pocketId,
  getPocketTier,
  getPocketBal,
  pocketTier,
  pocketBal,
  storeNavKey,
}) => {
  const [query, setQuery] = useState("");
  const [queryKey, setQueryKey] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [totalElements, setTotalElements] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  // const [transactionBals, setTransactionBals] = useState([])
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [pageNum, setPageNum] = useState(null);
  const [recordsPerPage] = useState(10);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const defaultURl = `${pocketId}/batch/payouts`;

  // const url =  query.length !== 0 && (!startDate || !endDate)
  //           ? `${defaultURl}&${ToCamelCase(queryKey)}=${query?.toLowerCase()}`

  //           : query.length !== 0 && startDate !== "" && endDate !== ""
  //           ? `${defaultURl}&${ToCamelCase(queryKey)}=${query?.toLowerCase()}&createdOnStartDate=${moment(startDate).format("DD-MM-YYYY")}&createdOnEndDate=${moment(endDate).format("DD-MM-YYYY")}`

  //           : (startDate && endDate === "")
  //           ? `${defaultURl}&createdOnStartDate=${moment(startDate).format("DD-MM-YYYY")}`

  //           : (startDate === "" && endDate)
  //           ? `${defaultURl}&createdOnEndDate=${moment(endDate).format("DD-MM-YYYY")}`

  //           : (startDate && endDate)
  //           ? `${defaultURl}&createdOnStartDate=${moment(startDate).format("DD-MM-YYYY")}&createdOnEndDate=${moment(endDate).format("DD-MM-YYYY")}`

  //           : defaultURl

  const mainURL = `${defaultURl}?size=${recordsPerPage}&page=${pageNum === null ? 1 : pageNum}`;

  const getCurrentPage = (pageNumber) => {
    setPageNum(pageNumber);
  };

  const fetchDataFunc = useCallback(async () => {
    console.log("fetching...");
    setLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL + mainURL}`,
        {
          size: recordsPerPage,
          page: pageNum === null ? 1 : pageNum,
          ...(startDate && {
            startDate: moment(startDate).format("DD-MM-YYYY"),
          }),
          ...(endDate && {
            endDate: moment(endDate).format("DD-MM-YYYY"),
          }),
          ...(query && queryKey === "batchId" && { batchId: query }),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearerToken}`,
            "Public-Key": `${publicKey}`,
          },
        },
      );
      if (res.data.code === "error") {
        setLoading(false);
        Alert("error", res.data.message);
      } else {
        setLoading(false);
        setBatchData(res.data.data.content);
        setTotalElements(res.data.data.pagination.totalElements);
        setTotalPages(res.data.data.pagination.totalPages);
      }
    } catch (error) {
      setLoading(false);
      setErrorState(true);
      handleException(error);
    }
  }, [
    bearerToken,
    publicKey,
    pageNum,
    recordsPerPage,
    startDate,
    endDate,
    pocketId,
    query,
    queryKey,
  ]);

  useEffect(() => {
    fetchDataFunc();
  }, [fetchDataFunc]);

  const viewBatchTransactions = (id) => {
    // navigate()

    setShowModal(true);
    const transactionFilter = batchData.filter((item) => item.batchId === id);
    const transactionItem = transactionFilter[0];
    setTransactionDetails(transactionItem);

    console.log("transactionItem:", transactionItem);
  };

  const columns = [
    {
      label: "Date created",
      render: (data) => (
        <TableDataSpan
          text={moment(data.createdAt).format("MMM DD, YYYY - LTS")}
          additionalClass="text-opacity-70 text-xs cursor-default"
          onClick={() => {}}
        />
      ),
    },
    {
      label: "Batch ID",
      render: (data) => (
        <TableDataSpan
          handleMouseEnter={() =>
            storeNavKey(
              `/dashboard/transactions/batch_transactions/${data.batchId}`,
            )
          }
          additionalClass="cursor-pointer"
        >
          <CopyText
            text={data.batchId}
            textStyle="text-opacity-70 text-xs mr-2 inline-block item-center text-blue-800 hover:underline"
            mssgStyle="-right-3 -top-[18px]"
            imgStyle="w-4 h-4"
          />
        </TableDataSpan>
      ),
    },
    {
      label: "Total",
      render: (data) => (
        <TableDataSpan
          // handleMouseEnter={() => storeNavKey(`/dashboard/transactions/batch_transactions/${data.batchId}`)}
          additionalClass="cursor-default"
          text={data.totalTransactions}
          onClick={() => {}}
        />
      ),
    },
    {
      label: "Pending",
      render: (data) => (
        <TableDataSpan
          // handleMouseEnter={() => storeNavKey(`/dashboard/transactions/batch_transactions/${data.batchId}`)}
          additionalClass="cursor-default"
          text={data.pendingCount}
          onClick={() => {}}
        />
      ),
    },
    {
      label: "Processed",
      render: (data) => (
        <TableDataSpan
          // handleMouseEnter={() => storeNavKey(`/dashboard/transactions/batch_transactions/${data.batchId}`)}
          additionalClass="cursor-default"
          text={data.processedCount}
          onClick={() => {}}
        />
      ),
    },
    {
      label: "Failed",
      render: (data) => (
        <TableDataSpan
          additionalClass="cursor-default"
          text={data.failedCount}
          onClick={() => {}}
        />
      ),
    },
    {
      label: "Status",
      render: (data) => {
        const {
          processedCount = 0,
          totalTransactions = 0,
          failedCount = 0,
          pendingCount = 0,
        } = data;

        const successfulCount = processedCount;
        const displayText = `${successfulCount} of ${totalTransactions} successful`;

        const isFullSuccess = successfulCount === totalTransactions;
        const isPartial = successfulCount > 0 && failedCount > 0;
        const isFailed = successfulCount === 0 && pendingCount === 0;

        const pillStyle = isFullSuccess
          ? "bg-green-100 text-green-700"
          : isPartial
            ? "bg-orange-50 text-orange-400"
            : isFailed
              ? "bg-red-100 text-red-500"
              : "bg-gray-100 text-gray-400";

        return (
          <TableDataSpan additionalClass="cursor-default" onClick={() => {}}>
            <span
              className={`text-xs font-medium px-3 py-1 rounded-md ${pillStyle}`}
            >
              {displayText}
            </span>
          </TableDataSpan>
        );
      },
    },
    // {
    //   label: 'Status',
    //   render: (data) => <TableDataSpan
    //     handleMouseEnter={() => storeNavKey(`/dashboard/transactions/batch_transactions/${data.batchId}`)}
    //     additionalClass='text-opacity-70 text-xs cursor-pointer'
    //   >
    //     <div className='flex gap-2 justify-start items-center'>
    //       <span className={`${data.status === 'Success'
    //         ? 'bg-Green_Accent8 text-Success2'
    //         : data.status === 'Failed'
    //           ? 'bg-DangerAccent5 text-Danger4'
    //           : 'bg-Yellow_Accent text-Yellow'} px-[10px] py-[5px] rounded-md`}>{data.status}</span>
    //     </div>
    //   </TableDataSpan>
    // }
  ];

  const NavData = [{ title: "Overview" }, { title: "Batches" }];

  return (
    <>
      <PageHeader
        pageTitle="Batch Transactions"
        pageTitleStyle=""
        exportTable={true}
        exportBatch={true}
        NoSearchBar={false}
        tableKeys={searchKeys}
        queryValue={query}
        setQuery={setQuery}
        setQueryKey={setQueryKey}

        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        tableHeaders={TransactionsHeader}
        tableData={batchData}
        csvUrl={defaultURl}
        navigation={true}
        navData={NavData}
        navDataLink={"transactions/"}
        resetPage={fetchDataFunc}
        batchLoading={loading}
      />

      <AppTable
        data={batchData}
        columns={columns}
        loading={loading}
        errorState={errorState}
        itemsPerPage={recordsPerPage}
        dataLength={totalElements}
        getCurrentPage={getCurrentPage}
      />
      {showModal && (
        <SideComponent
          toggleModal={() => setShowModal((prevState) => !prevState)}
          data={transactionDetails}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  pocketTier: state.app.pocketTier,
  pocketBal: state.app.pocketBal,
  modalState: state.app.modalState,
  bearerToken: state.auth.token,
  user_data: state.auth.user_data,
  publicKey: state.auth.public_key,
  pocketId: state.auth.pocket_data.pocketId,
});

const mapDispatchToProps = (dispatch) => ({
  toggleModal: () => dispatch(toggleModal()),
  getPocketTier: (data) => dispatch(getPocketTier(data)),
  getPocketBal: (data) => dispatch(getPocketBal(data)),
  storeNavKey: (data) => dispatch(storeNavKey(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
